// @ts-nocheck
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import {
  catchError, filter, switchMap, take, finalize,
} from 'rxjs/operators';
import {
  HttpHandler, HttpInterceptor, HttpRequest, HttpEvent,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RestApiService } from '../service/rest-api.service';
import { P } from '../ui-kit';

@Injectable()
export class RefreshTokenInterceptor implements HttpInterceptor {
  private whiteListEndpoint = [
    'refresh-token',
    // 'sign-in',
    // 'accredit',
    // 'set-password',
    // 'reset-password',
    // 'validate-token',
  ];

  private refreshTokenInProgress = false;

  private refreshTokenSubject: BehaviorSubject<string> = new BehaviorSubject<any>(null);

  constructor(private restApi: RestApiService) { }

  /**
   * intercept http requests
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // if request url is for rest api and has Authorization
    if (this.requestUrlIncludes(request, this.restApi.url)
      && !!request.headers.get('Authorization')) {
      // return handler with interceptor
      return next
        .handle(request)
        .pipe(
          catchError((error) => {
            // if request for white listed endpoints
            if (this.requestUrlIncludes(request, this.whiteListEndpoint)) {
              // nothing to do, return error
              return throwError(error);
            }
            // If not unauthorized error
            if (error.status !== 401) {
              // nothing to do, return error
              return throwError(error);
            }
            // If refreshTokenInProgress is true, wait until refreshTokenSubject has a non-null value
            if (this.refreshTokenInProgress) {
              // which means the new token is ready and we can retry the request again
              return this.refreshTokenSubject
                .pipe(
                  filter((token) => !!token),
                  take(1),
                  switchMap((token) => next.handle(this.addAuthenticationToken(request, token))),
                );
            }
            // initialize refresh token interception
            this.refreshTokenInProgress = true;
            // Set the refreshTokenSubject to null so that subsequent API calls will wait until the new token has been retrieved
            this.refreshTokenSubject.next(null);
            // refresh access token and add request
            return this.restApi
              .refreshAccessToken(this.restApi.accreditation?.refreshToken)
              .pipe(
                switchMap((token) => {
                  this.refreshTokenSubject.next(token);
                  return next.handle(this.addAuthenticationToken(request, token));
                }),
                catchError((refreshError) => throwError({ ...refreshError, originalError: error })),
                finalize(() => this.refreshTokenInProgress = false),
              );
          }),
        );
    }
    // not a rest api request, nothing to do
    return next
      .handle(request);
  }

  /**
   * clone request with auth
   */
  private addAuthenticationToken(request: HttpRequest<unknown>, token: string = this.restApi.accreditation?.token): HttpRequest<unknown> {
    // clone existing headers
    const headers: { [key: string]: string } = request.headers
      .keys()
      .reduce((obj, key) => ({ ...obj, [key]: request.headers.get(key) }), {});
    // if token present
    if (token) {
      // add to headers
      headers.Authorization = `Bearer ${token}`;
    } else {
      // remove from headers
      delete headers.Authorization;
    }
    // return request clone with auth (if token present)
    return request.clone({
      setHeaders: headers,
    });
  }

  /**
   * request url includes
   */
  private requestUrlIncludes(request: HttpRequest<unknown>, segments: string | string[]): boolean {
    return Array.isArray(segments)
      ? segments.reduce((includes, segment) => includes || request.url.includes(segment), false)
      : request.url.includes(segments);
  }
}
